<template>
	<div class="mt-2">
		<div class="text-center mt-2" v-for="contacto in contactos" :key="contacto.title">
			<h2>
				{{ contacto.title }}
			</h2>
			<p>
				{{ contacto.description }}
			</p>
			<div v-for="item in contacto.contact" :key="item.title">
				<h4>{{ item.title }}</h4>
				<pre>{{ item.value }}</pre>
			</div>
			<v-divider class="mt-3"></v-divider>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			contactos: [
				{
					title: "Biblioteca",
					description:
						"Es un centro cultural y de recursos para el aprendizaje del ucabista. Dentro del mismo puedes ver obras de arte, estudiar en espacios tranquilos y pedir prestados libros con tu carnet UCAB.",

					contact: [
						{
							title: "Correo",
							value: "bibliotecacentral@ucab.edu.ve",
						},
						{
							title: "Número de Teléfono",
							value: "0212-4076195",
						},
						{
							title: "Link",
							value: "https://biblioteca.ucab.edu.ve/",
						},
					],
				},
				{
					title: "Caja",
					description:
						"Es el lugar donde podrás realizar tus pagos ya sea de manera virtual (Caja virtual) o presencial.",
					contact: [
						{
							title: "Correo",
							value: "caja@ucab.edu.ve",
						},
						{
							title: "Número de Teléfono",
							value: `0212-4074191\n0212-4074338\n0212-4074382`,
						},
					],
				},
				{
					title: "Secretaría General",
					description:
						"Su papel es supervisar las actividades relacionadas con el progreso y la graduación de los estudiantes. Además, se encarga de proteger y gestionar los archivos de la institución, emitir y certificar los documentos emitidos por la Universidad, y desempeñar el papel de Secretario del Consejo Universitario.",
					contact: [
						{
							title: "Correo",
							value: "secretaria@ucab.edu.ve\nadmisiones@ucab.edu.ve",
						},

						{
							title: "Número de Teléfono - Atención al público. Módulo 4",
							value: "0212-4074277\n0212-4074282\n0212-4074476",
						},

						{
							title: "Número de Teléfono - Centro de Contacto UCAB",
							value:
								"0212-4076123\n0212-4076124\n0212-4076125\n0212-4076126\n0212-4076127\n0212-4076128\n0212-4076130\n0212-4076114\n0212-4076116",
						},
						{
							title: "Número de Teléfono - Identificación Institucional",
							value: "0212-4076121",
						},
						{
							title: "Link",
							value: "https://www.ucab.edu.ve/informacion-institucional/secretaria/",
						},
					],
				},
				{
					title: "Secretariado de Internacionalización",
					description:
						"Es una unidad de apoyo la cual diseña, planifica, gestiona, promueve y difunde el proceso de internacionalización.                                Ofrece el Programa Internacional de Desarrollo Académico, que permite a los estudiantes de la UCAB estudiar hasta 2 semestres en otras instituciones con las que la UCAB tiene convenios internacionales. Los estudiantes pueden cursar hasta 4 asignaturas por semestre y pagar la matrícula en moneda nacional. Además, brinda asesorías a otras universidades, facultades, escuelas, profesores y estudiantes, tanto nacionales como extranjeros.",
					contact: [
						{
							title: "Correo",
							value: "globalucab@gmail.com\ninternacionalizacion@ucab.edu.ve",
						},
						{
							title: "Número de Teléfono",
							value: `0212-4076061\n0212-4076062`,
						},
						{
							title: "Link",
							value: `https://internacionalizacion.ucab.edu.ve/`,
						},
					],
				},
			],
		};
	},
};
</script>

<style>
#acaadm h3,
#escuelas h3,
#ce h3,
#consejeros h3 {
	text-transform: uppercase;
	word-break: break-word;
}

.title-cont {
	word-break: break-word;
}

pre {
	text-wrap: pretty;
}
</style>
